var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box",
    staticStyle: {
      "min-width": "980px"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container content",
    staticStyle: {
      "padding": "0px 0px 20px 555px",
      "width": "894px",
      "border-bottom": "1px solid lightgrey"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin fa-lg opaque",
    staticStyle: {
      "margin-left": "290px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [(_vm.isIE) ? _c('a', {
    ref: "pdfIE"
  }, [_c('button', {
    staticClass: "button is-link"
  }, [_vm._v("\n                Download Insurance Certificate (PDF)\n                "), (!_vm.loading) ? _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isIE) ? _c('a', {
    ref: "pdf",
    attrs: {
      "download": _vm.fileName,
      "href": _vm.pdflink
    }
  }, [_c('button', {
    staticClass: "button is-link"
  }, [_vm._v("\n                Download Insurance Certificate (PDF)\n                "), (!_vm.loading) ? _c('i', {
    staticClass: "fa fa-lg fa-download",
    staticStyle: {
      "padding-left": "10px"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.association.Attachments && _vm.association.Attachments.length > 0) ? _c('div', {
    staticClass: "content is-small",
    staticStyle: {
      "margin-top": "20px",
      "max-width": "330px",
      "word-break": "break-all"
    }
  }, [_c('h4', [_vm._v("Additional Declarations")]), _vm._v(" "), _c('ul', {
    staticClass: "table",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px",
      "margin-bottom": "0px"
    }
  }, _vm._l((_vm.association.Attachments), function(attachment) {
    return _c('li', [_c('a', {
      attrs: {
        "href": attachment.downloadURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.fileName))])])
  }))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Accord24', {
    ref: "accord",
    attrs: {
      "readonly": true,
      "accord24": _vm.accord24
    }
  })], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d1ea94e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/request/RequestComplete.vue
// module id = rgl/
// module chunks = 1